import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemFamilyMember } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import { useTranslation } from "react-i18next";

const FamilyAssetDialog: React.FunctionComponent<{ requestDataCallback(): void; familyAsset: WalletItemFamilyMember; closeDialog(): void }> = (props) => {
    const [isLoading, setisLoading] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();

    const dispatch = useDispatch();
    const [familyAsset, setFamilyAsset] = useState(props.familyAsset);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [dateError, setDateError] = useState(false);
    const [birthDay, setBirthday] = useState({ day: "", month: "", year: "" });
    const [dateList, setDateList] = useState({
        days: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
        ],
    });
    const months = [
        { name: "Jan", value: "01" },
        { name: "Feb", value: "02" },
        { name: "Mar", value: "03" },
        { name: "Apr", value: "04" },
        { name: "May", value: "05" },
        { name: "Jun", value: "06" },
        { name: "Jul", value: "07" },
        { name: "Aug", value: "08" },
        { name: "Sep", value: "09" },
        { name: "Oct", value: "10" },
        { name: "Nov", value: "11" },
        { name: "Dec", value: "12" },
    ];
    const { register, errors, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });
    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    const parseDate = (bitrhday: string) => {
        if (bitrhday) {
            const date = bitrhday.split("/");
            if (date && date.length === 3) {
                return { day: date[1], month: date[0], year: date[2] };
            }
            return { day: "", month: "", year: "" };
        }
        return { day: "", month: "", year: "" };
    };

    const getDayLisOfMonth = (month: string, year: string) => {
        const yearInInt = parseInt(year);
        const monthInInt = parseInt(month);
        let days = new Array();
        if (yearInInt && monthInInt) {
            const maxDay = new Date(yearInInt, monthInInt, 0).getDate();

            for (let i = 1; i <= maxDay; i++) {
                if (i <= 9) {
                    days.push(`0${i}`);
                } else {
                    days.push(i.toString());
                }
            }
            return days;
        }
        return days;
    };

    useEffect(() => {
        if (familyAsset.dob) {
            const parsedBirthDay = parseDate(familyAsset.dob);
            const dayListofMonth = getDayLisOfMonth(parsedBirthDay.month, parsedBirthDay.year);
            if (dayListofMonth && dayListofMonth.length > 0) {
                setDateList({ days: dayListofMonth });
            }
            setBirthday(parsedBirthDay);
        }
    }, []);

    function onChangeHandler(event: any) {
        const name = event.currentTarget.name;
        setFamilyAsset({ ...familyAsset, [name as string]: event.currentTarget.value });
    }

    function onDateChange(event: any) {
        let totalInput = 0;
        const name = event.currentTarget.name;
        if (name === "day") {
            if (event.currentTarget.value) {
                totalInput++;
            }
            if (birthDay.month) {
                totalInput++;
            }
            if (birthDay.year) {
                totalInput++;
            }
        }
        if (name === "month") {
            const dayListofMonth = getDayLisOfMonth(event.currentTarget.value, birthDay.year);
            if (dayListofMonth && dayListofMonth.length > 0) {
                setDateList({ days: dayListofMonth });
            }
            if (event.currentTarget.value) {
                totalInput++;
            }
            if (birthDay.day) {
                totalInput++;
            }
            if (birthDay.year) {
                totalInput++;
            }
        }
        if (name === "year") {
            const dayListofMonth = getDayLisOfMonth(birthDay.month, event.currentTarget.value);
            if (dayListofMonth && dayListofMonth.length > 0) {
                setDateList({ days: dayListofMonth });
            }
            if (event.currentTarget.value) {
                totalInput++;
            }
            if (birthDay.month) {
                totalInput++;
            }
            if (birthDay.day) {
                totalInput++;
            }
        }
        setBirthday({ ...birthDay, [name as string]: event.currentTarget.value });

        if (totalInput === 0 || totalInput === 3) {
            setDateError(false);
        } else {
            setDateError(true);
        }
    }

    const saveItem = () => {
        let requestItem = {
            ...familyAsset,
            dob: birthDay.month + "/" + birthDay.day + "/" + birthDay.year,
        };
        const requestBody = {
            "lost-wallet": {
                "lost-family-member": requestItem,
            },
        };

        if (!dateError) {
            setisLoading(true);
            httpClient
                .sendRequest("POST", "api/lostWallet/updateWalletItem", requestBody)
                .then((data) => {
                    setisLoading(false);
                    if (data.isSuccess) {
                        if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                            completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                        }
                        Notification({
                            type: "success",
                            title: tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.updateToastTitle"),
                            message: tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.updateToastMessage"),
                        });
                        refresWalletItem();
                    } else {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.errorToastTitle"),
                            message: tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.errorToastMesage"),
                        });
                        refresWalletItem();
                    }
                })
                .catch(function (error) {
                    setisLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: error,
                        duration: 0,
                    });
                    closeDialog();
                });
        }
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-edit"></em>
                        </div>
                        <h1>{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.title")} - {props.familyAsset.firstName + " " + props.familyAsset.lastName}</h1>
                    </div>

                    <form onSubmit={handleSubmit(saveItem)} id="family-asset-form-container">
                        <div className="dialog-body">
                            <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-first-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.fname")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className={errors.firstName ? "status-error inputbox" : "inputbox"}
                                            id="edit-first-name"
                                            name="firstName"
                                            defaultValue={familyAsset.firstName ? familyAsset.firstName : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.FIRSTNAME.pattern,
                                            })}
                                            maxLength={30}
                                            aria-required="true"
                                        />
                                        {errors.firstName && errors.firstName.type === "pattern" && (
                                            <span className="form-error">{tLang(PATTERNS.FIRSTNAME.message)}</span>
                                        )}
                                        {errors.firstName && errors.firstName.type === "required" && <span className="form-error">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.firstName.required")}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["middleName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-middle-initial">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.mName")}</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-middle-initial"
                                            aria-labelledby="edit-middle-initial"
                                            name="middleName"
                                            defaultValue={familyAsset.middleName ? familyAsset.middleName : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: PATTERNS.MIDDLE_INITIAL.pattern,
                                            })}
                                            maxLength={1}
                                        />
                                        {errors.middleName && errors.middleName.type === "pattern" && (
                                            <span className="form-error">{tLang(PATTERNS.MIDDLE_INITIAL.message)}</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-last-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.lName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-last-name"
                                            name="lastName"
                                            defaultValue={familyAsset.lastName ? familyAsset.lastName : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.LASTNAME.pattern,
                                            })}
                                            maxLength={30}
                                            aria-required="true"
                                        />
                                        {errors.lastName && errors.lastName.type === "pattern" && <span className="form-error">{tLang(PATTERNS.LASTNAME.message)}</span>}

                                        {errors.lastName && errors.lastName.type === "required" && <span className="form-error">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.lastName.required")}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-suffix">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.suffix")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="edit-suffix"
                                        aria-labelledby="edit-suffix"
                                        name="generationSuffix"
                                        defaultValue={familyAsset.generationSuffix ? familyAsset.generationSuffix : ""}
                                        onChange={onChangeHandler}
                                    >
                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.dropdownHeaders.suffix")}</option>
                                        <option value="Sr">Sr</option>
                                        <option value="Jr">Jr</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-relationship">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relationship")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="edit-relationship"
                                        name="relationship"
                                        defaultValue={familyAsset.relationship ? familyAsset.relationship : ""}
                                        onChange={onChangeHandler}
                                    >
                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.dropdownHeaders.relatioship")}</option>
                                        <option value="CHILD_BOY">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.childBoy")}</option>
                                        <option value="CHILD_GIRL">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.childGirl")}</option>
                                        <option value="DOMESTIC_PARTNER">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.domesticPartner")}</option>
                                        <option value="HUSBAND">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.husband")}</option>
                                        <option value="WIFE">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.wife")}</option>
                                        <option value="YOUNG_ADULT">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.relatioshipDropDownList.youngAdult")}</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-dob-day">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.dob")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        <div className="col-xs-4 col-no-gutter">
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-dob-day-1">Date of Birth Day</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                                                    <select
                                                        ref={register}
                                                        name="day"
                                                        role="listbox"
                                                        className="inputbox"
                                                        id="label-dob-day"
                                                        value={birthDay.day}
                                                        onChange={onDateChange}
                                                    >
                                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.dropdownHeaders.dateDay")}</option>
                                                        {dateList.days.map((day, index) => {
                                                            return (
                                                                <option key={index} value={day}>
                                                                    {day}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-4 col-no-gutter">
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-dob-month">Date of Birth Month</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                                                    <select
                                                        ref={register}
                                                        name="month"
                                                        role="listbox"
                                                        className="inputbox"
                                                        id="label-dob-month"
                                                        value={birthDay.month}
                                                        onChange={onDateChange}
                                                    >
                                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.dropdownHeaders.dateMonth")}</option>
                                                        {months.map((month) => {
                                                            return (
                                                                <option key={month.value} value={month.value}>
                                                                    {month.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-4 col-no-gutter">
                                            <div className="form-row row">
                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                    <label htmlFor="label-dob-year">Date of Birth Year</label>
                                                </div>
                                                <div className="form-input col-xs-12 col-no-gutter">
                                                    <select
                                                        ref={register}
                                                        name="year"
                                                        role="listbox"
                                                        className="inputbox"
                                                        id="label-dob-year"
                                                        value={birthDay.year}
                                                        onChange={onDateChange}
                                                    >
                                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.dropdownHeaders.dateYear")}</option>
                                                        {Array(115)
                                                            .fill(null)
                                                            .map((value, index) => {
                                                                const optionValue = new Date().getFullYear() - index;
                                                                return (
                                                                    <option key={optionValue} value={optionValue}>
                                                                        {optionValue}
                                                                    </option>
                                                                );
                                                            })}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {dateError && isSubmitted && <span className="form-error">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.date.required")}</span>}
                                </div>
                            </div>

                            <div className={errors["ssn"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-ssn">SSN</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-ssn"
                                            aria-labelledby="edit-ssn"
                                            name="ssn"
                                            defaultValue={familyAsset.ssn ? familyAsset.ssn : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: /^$|^[(]?\d{3}[)]?[-]?\d{2}[-]?\d{4}$/,
                                            })}
                                        />

                                        {errors.ssn && errors.ssn.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.ssn.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["driverLicenseNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-license-number">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.licenseNumber")}</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-license-number"
                                            aria-labelledby="edit-license-number"
                                            name="driverLicenseNumber"
                                            defaultValue={familyAsset.driverLicenseNumber ? familyAsset.driverLicenseNumber : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: PATTERNS.LICENCENUMBER.pattern,
                                                minLength: 4,
                                                maxLength: 30,
                                            })}
                                            maxLength={30}
                                        />

                                        {errors.driverLicenseNumber && errors.driverLicenseNumber.type === "pattern" && (
                                            <span className="form-error">{tLang(PATTERNS.LICENCENUMBER.message)}</span>
                                        )}

                                        {errors.driverLicenseNumber && errors.driverLicenseNumber.type === "minLength" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.licenseNumber.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["email"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-email">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.email")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            id="edit-email"
                                            name="email"
                                            defaultValue={familyAsset.email ? familyAsset.email : ""}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.EMAIL.pattern,
                                            })}
                                            maxLength={PATTERNS.EMAIL.maxLength}
                                            aria-required="true"
                                        />
                                        {errors.email && errors.email.type === "pattern" && <span className="form-error">{tLang(PATTERNS.EMAIL.message)}</span>}

                                        {errors.email && errors.email.type === "required" && <span className="form-error"> {tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.validationMessage.email.required")}</span>}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        aria-labelledby="edit-notes"
                                        name="notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        onChange={onChangeHandler}
                                        defaultValue={familyAsset.notes ? familyAsset.notes : ""}
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.cancelButtonText")}</span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button onClick={() => setIsSubmitted(true)} type="submit" className="btn-default btn-primary">
                                        <span className="btn-text">{tLang("identityVault.secureStorage.lostWallterWidget.familyMemberDialog.label.saveButtonText")}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default FamilyAssetDialog;
